import { useTranslation } from "react-i18next"
import type { FuelSummary } from "./fuelReportSummary"

function Stat({
  label,
  value,
  sub,
}: {
  label: string
  value: string
  sub?: string
}) {
  return (
    <div>
      <div className="text-sm font-semibold">{label}</div>
      <div className="text-5xl font-bold tracking-tight">{value}</div>
      {sub && <div className="mt-1 text-sm text-muted-foreground">{sub}</div>}
    </div>
  )
}

export function FuelSummaryCard({ summary }: { summary: FuelSummary }) {
  const { t } = useTranslation()
  return (
    <div className="mb-4 rounded-xl border bg-background p-6">
      <h2 className="mb-4 text-xl font-bold">
        {t("reports.fuelSummary.title")}
      </h2>
      <div className="grid grid-cols-2 gap-6 md:grid-cols-4">
        <Stat
          label={t("reports.fuelSummary.refuels")}
          value={String(summary.refuels)}
        />
        <Stat
          label={t("reports.fuelSummary.atSuggestedStation")}
          value={String(summary.matched)}
          // "outside suggested" = all refuels not at a suggested station (incl.
          // no-alert ones) — deliberately NOT the table's "Elsewhere" column,
          // which counts only post-alert refuels elsewhere.
          sub={t("reports.fuelSummary.outsideSuggested", {
            number: summary.elsewhere,
          })}
        />
        <div className="md:border-l md:pl-6">
          <Stat
            label={t("reports.fuelSummary.alertsSent")}
            value={String(summary.alertsSent)}
            sub={
              summary.alertsNotSent > 0
                ? t("reports.fuelSummary.notSent", {
                    number: summary.alertsNotSent,
                  })
                : undefined
            }
          />
        </div>
        <Stat
          label={t("reports.fuelSummary.seen")}
          value={summary.hasSeenData ? String(summary.seen) : "—"}
          sub={
            summary.hasSeenData
              ? t("reports.fuelSummary.notSeen", { number: summary.notSeen })
              : t("reports.fuelSummary.noData")
          }
        />
      </div>
    </div>
  )
}
